<dx-popup
    [title]="'Information Change Request'"
    [(visible)]="visible"
    [fullScreen]="!!(screen.xSmallScreenChanged | async)"
    [width]="550"
    [height]="'auto'"
    (onHidden)="onClose()"
    [wrapperAttr]="{'class':'form-popup'}"
    [animation]="{ show: { type: 'fadeIn', duration: 200 }, hide: { type: 'fadeOut', duration: 200 } }"
    [showCloseButton]="true"
>
    @if (request) {
        <div class="row mb-3">
            <div class="col-sm-6 d-flex align-items-center">
                <strong class="me-2">Status:</strong>
                <span class="badge" [ngClass]="getBadgeClass(request.status)">
                {{ request.status | capitalCase }}
            </span>
            </div>
            <div class="col-sm-6">
                <strong>ID:</strong>
                <span class="text-muted">
                {{ request.number }}
            </span>
            </div>
        </div>
    }

    <dx-validation-group #validationGroup>
        @if (formData) {
            <div class="row">
                <div class="col-12 mb-3">
                    <label class="form-label">Employee*</label>
                    <pictured-item-select-box
                        [value]="formData.employee.id"
                        (valueChange)="onEmployeeChange($event)"
                        [dataSource]="employeesDataSource"
                        [readOnly]="!canEditEmployee"
                    ></pictured-item-select-box>
                </div>
                <div class="col-12 mb-3">
                    <dx-select-box
                        stylingMode="filled"
                        label="Type of Change*"
                        [(value)]="formData.typeOfChange"
                        (onValueChanged)="onTypeChange($event)"
                        [dataSource]="typeOfChangeOptions"
                        [readOnly]="!canEdit"
                        [searchEnabled]="true"
                        valueExpr="value"
                        displayExpr="text"
                    >
                        <dx-validator>
                            <dxi-validation-rule type="required"></dxi-validation-rule>
                        </dx-validator>
                    </dx-select-box>
                </div>
                @if (formData.typeOfChange == ChangeRequestType.BankAccount) {
                    <div class="col-6 mb-3">
                        <dx-text-box
                            stylingMode="filled"
                            label="Institution Number *"
                            [(value)]="formData.institutionNumber"
                            [readOnly]="!canEdit"
                            [mask]="'#########'"
                            [maskChar]="' '"
                        >
                            <dx-validator>
                                <dxi-validation-rule type="required" [max]="9"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                    <div class="col-6 mb-3">
                        <dx-text-box
                            stylingMode="filled"
                            label="Transit Number *"
                            [(value)]="formData.transitNumber"
                            [readOnly]="!canEdit"
                            [mask]="'#########'"
                            [maskChar]="' '"
                        >
                            <dx-validator>
                                <dxi-validation-rule type="required" [max]="9"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                    <div class="col-12 mb-3">
                        <dx-text-box
                            stylingMode="filled"
                            label="Account Number *"
                            [(value)]="formData.accountNumber"
                            [readOnly]="!canEdit"
                            [mask]="'#########'"
                            [maskChar]="' '"
                        >
                            <dx-validator>
                                <dxi-validation-rule type="required" [max]="12"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                    <div class="col-12 mb-3">
                        @if (canEdit) {
                            <dx-file-uploader
                                selectButtonText="Upload void cheque or DDF:"
                                uploadMode="useForm"
                                [(value)]="files"
                                [disabled]="!canEdit"
                                [multiple]="true"
                            ></dx-file-uploader>
                        } @else {
                            @if (formData.chequeFile) {
                                <div class="mt-3">
                                    <a href="#" [appSignedLink]="formData.chequeFile.fileUrl">
                                        {{ formData.chequeFile.fileName }}
                                    </a>
                                </div>
                            }
                        }
                    </div>
                } @else {
                    <div class="col-12 mb-3">
                        <dx-text-box
                            stylingMode="filled"
                            label="Old Value"
                            [value]="oldValue | async"
                            [readOnly]="true"
                        >
                        </dx-text-box>
                    </div>
                    <div class="col-12 mb-3">
                        <dx-text-box
                            stylingMode="filled"
                            label="New Value*"
                            [(value)]="formData.newValue"
                            [readOnly]="!canEdit"
                        >
                            <dx-validator>
                                <dxi-validation-rule type="required"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                }
                <div class="col-12 mb-3">
                    <dx-text-area
                        label="Reason for change*"
                        stylingMode="filled"
                        [height]="70"
                        [(value)]="formData.reasonForChange"
                        [readOnly]="!canEdit"
                    >
                        <dx-validator>
                            <dxi-validation-rule type="required"></dxi-validation-rule>
                        </dx-validator>
                    </dx-text-area>
                </div>
            </div>
        }
    </dx-validation-group>

    <dxi-popup-toolbar-item toolbar="bottom" location="center">
        <div class="d-flex align-items-center justify-content-end gap-3">
            @if (canEdit) {
                <dx-button
                    text="Submit"
                    stylingMode="contained"
                    type="default"
                    (onClick)="onSave()"
                ></dx-button>
                <dx-button
                    text="Cancel"
                    stylingMode="contained"
                    type="normal"
                    (onClick)="onClose()"
                ></dx-button>
            } @else {
                @if (formData.canApprove && auth.checkPermission(PermissionType.InformationChangeRequestsStatusChange, AccessType.Manage)) {
                    <dx-button
                        text="Approve"
                        stylingMode="contained"
                        type="success"
                        (onClick)="changeStatus(ChangeRequestStatus.Approved)"
                    ></dx-button>
                }
                @if (formData.canDecline && auth.checkPermission(PermissionType.InformationChangeRequestsStatusChange, AccessType.Manage)) {
                    <dx-button
                        text="Decline"
                        stylingMode="contained"
                        type="danger"
                        (onClick)="changeStatus(ChangeRequestStatus.Declined)"
                    ></dx-button>
                }
                @if (formData.canWithdraw) {
                    <dx-button
                        text="Withdrawn"
                        stylingMode="contained"
                        type="normal"
                        (onClick)="changeStatus(ChangeRequestStatus.Withdrawn)"
                    ></dx-button>
                }
                @if (formData.canComplete && auth.checkPermission(PermissionType.HrApprovalInformationChange, AccessType.Manage)) {
                    <dx-button
                        text="Complete"
                        stylingMode="contained"
                        type="success"
                        (onClick)="changeStatus(ChangeRequestStatus.Completed)"
                    ></dx-button>
                }
            }
        </div>
    </dxi-popup-toolbar-item>

    @if (request) {
        <div class="row mt-3">
            <div class="col-sm-6 d-flex align-items-start">
                <strong class="me-2">Date Submitted:</strong>
                {{ request.submittedDate | date: 'longDate' }}
            </div>
            <div class="col-sm-6 d-flex flex-column align-items-end">
                @if (request.finalizedDate) {
                    <div style="text-align: left;">
                        <div class="mb-1">
                            <strong class="me-2">Date Finalized:</strong>
                            {{ request.finalizedDate | date: 'longDate' }}
                        </div>
                        @if(request.lastModifiedByName){
                            <div>
                                <strong class="me-2">By:</strong>
                                {{ request.lastModifiedByName }}
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    }
</dx-popup>
